import { styled, Grid } from "@mui/material";

export const ActionsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "10px",
  "& .MuiButton-root": {
    textTransform: "none !important",
    justifyContent: "flex-start",
    padding: "0px !important",
  },
});
